<template>
  <div class="fourElements">
    <div class="fourElementsContainer">
      <div class="oh fl  mr20">
        <div class="fl lh30">站点：</div>
        <div class="fl">
          <a-select
            max-tag-count="responsive"
            ref="select"
            mode="multiple"
            v-model:value="searchParams.siteIds"
            style="width: 220px"
            @change="initList"
          >
            <a-select-option
              :value="item.id"
              :key="key"
              v-for="(item, key) in sites"
              >{{ item.name }}</a-select-option
            >
          </a-select>
        </div>
      </div>
      <div class="oh fl mr20">
        <div class="fl lh30">终端：</div>
        <div class="fl">
          <a-select
            max-tag-count="responsive"
            ref="select"
            mode="multiple"
            v-model:value="searchParams.terminalIds"
            style="width: 220px"
            @change="initList"
          >
            <a-select-option :value="1" key="web">WEB</a-select-option>
            <a-select-option :value="2" key="app">APP</a-select-option>
          </a-select>
        </div>
      </div>
      <div class="oh fl">
        <div class="fl lh30">月份：</div>
        <div class="fl">
          <a-select
            max-tag-count="responsive"
            ref="select"
            mode="multiple"
            v-model:value="searchParams.months"
            style="width: 220px"
            @change="initList"
          >
            <a-select-option
              :value="item.value"
              v-for="(item, key) in [...monthOptions]"
              :key="key"
              >{{ item.label }}</a-select-option
            >
          </a-select>
        </div>
      </div>
    </div>
    <div class="tar">
      <a-button type="primary" @click="() => changeVisible(true, null)"
        >批量新增</a-button
      >
    </div>
  </div>
</template>
<script>
import { inject, toRefs } from 'vue'
export default {
  setup() {
    return {
      ...toRefs(inject('initState'))
    }
  }
}
</script>
<style scoped>
.fourElements {
  background: #ffffff;
  padding: 10px 20px 20px 20px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}

.fourElementsContainer {
  display: flex;
  flex-direction: row;
}
</style>
